<template>
  <div class="checkVideo">
    <div class="top-type">
      <span>商品展示视频内容的方式:</span>
      <el-radio-group v-model="videoTypeValue" @change="changeType">
        <el-radio :label="1">层级</el-radio>
        <el-radio :label="0">非层级</el-radio>
      </el-radio-group>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="单节点类型新增" name="first">
        <el-card>
          <!-- 功能区 搜索添加等 -->
          <el-row>
            <el-col style="float: right; margin-bottom: 20px">
              <el-button type="primary" @click="sortByName(1)">正序</el-button>
              <el-button type="primary" @click="sortByName(0)">倒序</el-button>
              <el-upload
                ref="upload"
                :action="materialsFileAction"
                style="float: right"
                :on-change="getUploadNumber"
                :http-request="amountFileUploadRequest"
                multiple
                :show-file-list="false"
              >
                <el-button
                  type="primary"
                  plain
                  slot="trigger"
                  style="background-color: #409eff; color: #fff"
                  >点击上传</el-button
                >
              </el-upload>
            </el-col>
          </el-row>
          <!-- ------------------ -->
          <!-- 内容区 -->
          <div v-loading="webLoading">
            <el-table
              ref="multipleTables"
              :data="page.rows"
              tooltip-effect="dark"
              style="width: 100%"
              border
              @selection-change="selectionChangeLeft"
            >
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column
                prop="orderby"
                label="排序"
                width="50"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="附件"
                :show-overflow-tooltip="true"
              ></el-table-column>

              <el-table-column
                prop="size"
                label="大小"
                :show-overflow-tooltip="true"
                width="100"
                align="center"
              >
                <template slot-scope="scope" v-if="scope.row.size != null"
                  >{{ (scope.row.size / 1024 / 1024).toFixed(4) }}MB</template
                >
              </el-table-column>
              <el-table-column prop label="操作" width="160" align="center">
                <template slot-scope="scope">
                  <div class="operationGroup">
                    <el-button
                      type="text"
                      size="small"
                      @click="
                        downloadMaterialFile(
                          scope.row.url,
                          scope.row.name,
                          scope
                        )
                      "
                      >下载</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      @click="deleteFile(scope.row)"
                      >删除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- ----------------------- -->
          <!-- <el-pagination
            :key="page.total"
            background
            layout="total, sizes, prev, pager, next"
            style="margin-top: 20px; text-align: right"
            :total="page.total"
            :page-sizes="[10, 20, 30, 40]"
            :small="true"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination> -->
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="层级类型新增" name="second">
        <el-card>
          <el-row>
            <el-col :span="10" style="float: right">
              <el-button-group style="float: right">
                <el-button
                  type="primary"
                  @click="dialogLevelVisible = true"
                  icon="el-icon-plus"
                  >添加分组</el-button
                >
              </el-button-group>
            </el-col>
          </el-row>

          <!--table-->
          <el-table
            :data="tableData"
            style="width: 100%; margin-bottom: 20px; margin-top: 20px"
            :row-key="getRowKeys"
            :expand-row-keys="expands"
            @expand-change="expandSelect"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-button type="primary" @click="sortByName(1, props.$index)"
                  >正序</el-button
                >
                <el-button type="primary" @click="sortByName(0, props.$index)"
                  >倒序</el-button
                >
                <el-table
                  :data="props.row.attachmentList"
                  style="width: 100%; margin-bottom: 20px; margin-top: 20px"
                  row-key="id"
                  border
                  default-expand-all
                  :tree-props="{
                    children: 'children',
                    hasChildren: 'hasChildren',
                  }"
                >
                  <el-table-column prop="orderby" label="序号" sortable>
                  </el-table-column>
                  <el-table-column prop="name" label="资料名称" sortable>
                  </el-table-column>
                  <el-table-column label="大小">
                    <template slot-scope="scope" v-if="scope.row.size != null"
                      >{{
                        (scope.row.size / 1024 / 1024).toFixed(4)
                      }}MB</template
                    >
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-popconfirm
                        confirm-button-text="确定"
                        cancel-button-text="取消"
                        icon="el-icon-info"
                        icon-color="red"
                        title="确定解绑吗？"
                        style="margin-right: 20px"
                        @confirm="
                          delSubjectVideoRelation(
                            scope.row.subjectVideoRelationId
                          )
                        "
                      >
                        <el-button type="text" slot="reference">解绑</el-button>
                      </el-popconfirm>
                      <el-button
                        type="text"
                        size="small"
                        @click="updateInfo(scope)"
                        style="margin-right: 10px"
                        >编辑</el-button
                      >
                      <el-button
                        type="text"
                        size="small"
                        @click="
                          downloadMaterialFile(
                            scope.row.url,
                            scope.row.name,
                            scope
                          )
                        "
                        >下载</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column label="分组名称" prop="name"> </el-table-column>

            <!-- <el-table-column label="描述" prop="desc"> </el-table-column> -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span
                  @click="groupDelete(scope.row.id)"
                  style="margin-right: 30px; float: left"
                  class="mainColor"
                  >删除分组</span
                >
                <el-upload
                  ref="upload"
                  style="float: left"
                  :action="materialsFileAction"
                  :on-change="getUploadRelationNumber"
                  :http-request="uploadFileTree"
                  multiple
                  :show-file-list="false"
                >
                  <span
                    style="margin-right: 30px"
                    class="mainColor"
                    icon="el-icon-plus"
                    @click="relationId = scope.row.id"
                    >上传资料</span
                  >
                </el-upload>
                <span
                  @click="editBtn(scope.row)"
                  class="mainColor"
                  icon="el-icon-plus"
                  >编辑</span
                >
              </template>
            </el-table-column>
          </el-table>
          <!--table2-->
          <!-- <el-table
            :data="levelTabel"
            style="
              width: 100%;
              margin-bottom: 20px;
              margin-top: 20px;
              display: none;
            "
            row-key="id"
            border
            default-expand-all
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          >
            <el-table-column
              prop="date"
              label="所属分组/课程"
              sortable
              width="180"
            >
            </el-table-column>
            <el-table-column prop="name" label="名称" sortable>
            </el-table-column>
            <el-table-column prop="address" label="类型"> </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span style="margin-right: 30px" class="mainColor">添加</span>
                <el-popconfirm
                  confirm-button-text="确定"
                  cancel-button-text="取消"
                  icon="el-icon-info"
                  icon-color="red"
                  title="确定解绑吗？"
                >
                  <el-button type="text" slot="reference">解绑</el-button>
                </el-popconfirm>
                <span style="margin-left: 30px" class="mainColor">查看</span>
              </template>
            </el-table-column>
          </el-table> -->
        </el-card>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="添加分组" :visible.sync="dialogLevelVisible">
      <el-form :model="form">
        <el-form-item label="分组名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input-number v-model="form.sort"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="levelSure()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑资料" :visible.sync="dialogMaterialVisible">
      <el-form :model="form">
        <el-form-item label="资料名称" :label-width="formLabelWidth">
          <el-input
            v-model="editMaterialForm.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input-number v-model="editMaterialForm.sort"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editCancel()">取 消</el-button>
        <el-button type="primary" @click="submitEditForm()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog
      title="选择视频"
      :visible.sync="selectVideoVisible"
      width="800px"
      left
    >
      <videoMaterial
        @videoListChange="changeVideoList"
        v-if="selectVideoVisibleBlock"
      ></videoMaterial>
    </el-dialog> -->
  </div>
</template>

<script>
import videoMaterial from "../common/videoMaterial";
import { uploadOSS } from "../../upload/upload";
import draggable from "vuedraggable";
export default {
  components: { draggable, videoMaterial },
  created() {},

  data() {
    return {
      materialsFileAction: `${process.env.POI_URL}/videoInfo/upload`,
      options: [
        {
          value: 1,
          label: "层级",
        },
        {
          value: 0,
          label: "非层级",
        },
      ],
      videoTypeValue: 0,
      MaterialsVideoCourseId: "",
      materialsImportList: [],
      activeName: "first",
      searchForm: {
        name: "",
      },
      page: {
        // pageNumber: 1,
        // pageSize: 10,
        // total: 0,
        rows: [],
      },
      tableData: [],
      uploadArr: [],
      uploadNumber: 0,
      uploadRelationNum: 0,
      webLoading: false,
      dialogLevelVisible: false,
      Aliyun: "",
      formLabelWidth: "100px",
      form: {
        name: "",
        sort: 0,
      },
      relationId: "",
      uploadItemLength: 0,
      dialogMaterialVisible: false,
      editMaterialForm: {
        name: "",
        tryUse: false,
        tryDuration: 5,
        sort: 0,
      },
      expands: [],
    };
  },
  methods: {
    getRowKeys(row) {
      return row.index;
    },
    expandSelect(row, expandedRows) {
      var that = this;
      if (expandedRows.length) {
        that.expands = [];
        if (row) {
          that.expands.push(row.index); // 每次push进去的是每行的ID
        }
      } else {
        that.expands = []; // 默认不展开
      }
    },
    sortByName(val, index) {
      let apiName;
      let obj = {
        sortState: val,
        type: 2,
      };
      console.log(index);
      if (index == undefined) {
        apiName = "updateVideoInfoSort";
        obj.videoCourseId = this.MaterialsVideoCourseId;
      } else {
        apiName = "updateSubjectVideo";
        obj.id = this.tableData[index].id;
      }
      this.api.videoInfo[apiName](obj).then(() => {
        if (index == undefined) {
          this.getMaterialList();
        } else {
          this.getMaterialListTree();
        }
      });
    },
    /**
     * 取消按钮
     */
    cancel() {
      this.dialogLevelVisible = false;
      this.form = {
        name: "",
        sort: 0,
      };
    },
    editCancel() {
      this.dialogMaterialVisible = false;
      this.editMaterialForm = {
        name: "",
        sort: 0,
      };
    },
    submitEditForm() {
      this.api.videoMaterials
        .updateAttachment(this.editMaterialForm)
        .then((res) => {
          if (res.success) {
            this.dialogMaterialVisible = false;
            this.getMaterialListTree();
          }
        })
        .catch((err) => console.log(err));
    },
    /**
     * 获取阿里云数据
     */
    async getAliyun() {
      this.api.upload().then((result) => {
        this.Aliyun = result.data;
      });
    },

    checkStatus(id) {
      this.api.videoInfo
        .getVideoShowWay({
          videoCourseId: id,
          type: 2,
        })
        .then((res) => {
          this.videoTypeValue = res.data.showState;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * 设置显示方式 以层级或非层级展示
     */
    changeType(val) {
      //切换状态
      this.api.videoInfo
        .videoShowWay({
          videoCourseId: this.$route.query.id,
          showState: this.videoTypeValue,
          type: 2,
        })
        .then((result) => {
          if (result.success) {
            this.checkStatus(this.MaterialsVideoCourseId);
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectionChangeLeft() {},
    pageListLeft() {
      console.log(123);
    },
    // ===============单节点=====================
    /**
     * 获取单节点资料列表
     */
    getMaterialList(id) {
      this.getAliyun();

      this.materialsImportList = [];
      this.api.videoMaterials
        .getVideoMaterials({ videoCourseId: this.MaterialsVideoCourseId })
        .then((result) => {
          if (result.success) {
            this.page.rows =
              result.data &&
              result.data.attachmentList &&
              result.data.attachmentList.length > 0
                ? this.fixOrder(result.data.attachmentList)
                : [];
            // this.page.total = result.data.attachmentList.length
          }
        });
    },
    /**
     * 上传资料序号 ????
     */
    getUploadNumber() {
      this.uploadLoading = true;
      this.uploadNumber = this.uploadNumber + 1;
    },
    /**
     * 上传资料
     */
    amountFileUploadRequest(file) {
      this.uploadArr = [];
      uploadOSS(file, this.Aliyun, "materials").then((result) => {
        let obj = {
          name: file.file.name,
          size: file.file.size,
          type: file.file.type,
          url: result,
        };
        let obj2 = {
          videoCourseId: this.MaterialsVideoCourseId,
          attachment: obj,
        };
        this.uploadArr.push(obj2);
        console.log(this.uploadArr);
        if (this.uploadArr.length === this.uploadNumber) {
          this.addBatchVideoMaterials();
        }
      });
    },
    /**
     * 批量新增资料
     */
    addBatchVideoMaterials() {
      this.api.videoMaterials
        .addBatchVideoMaterials(this.uploadArr)
        .then((result) => {
          if (result.success) {
            this.uploadLoading = false;
            this.uploadArr = [];
            this.uploadNumber = 0;
            this.getMaterialList(this.MaterialsVideoCourseId);
          } else {
            this.uploadArr = [];
            this.uploadNumber = 0;
            this.$message.error(result.message);
          }
        });
    },
    /**
     * 下载资料
     */
    downloadMaterialFile(url, name, item) {
      window.open(url, "_blank");
    },
    /**
     * 删除资料文件
     */
    deleteFile(item) {
      this.$confirm("系统将删除该文件，是否确认删除？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          let obj = {
            id: item.id,
          };
          this.api.attachment.deleteAttachment([obj]).then((result) => {});
          let result = [];
          this.page.rows.forEach((e, index) => {
            if (e.id !== item.id) {
              result.push(e);
            }
          });
          this.page.rows = this.fixOrder(result);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // ===========================================

    /**
     * 给列表新增序号字段，用于排序
     */
    fixOrder(arr) {
      for (let k in arr) {
        arr[k].orderby = parseInt(k) + 1;
      }
      return arr;
    },

    // ==============层级=========================
    /**
     * 新建层级
     */
    levelSure() {
      if (this.form.id) {
        this.api.videoInfo.updateSubjectVideo(this.form).then((res) => {
          if (res.success) {
            this.dialogLevelVisible = false;
            this.$message.success(res.message);
            this.getMaterialListTree();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.api.videoInfo
          .addSubjectVideo({
            videoCourseId: this.MaterialsVideoCourseId,
            sort: this.form.sort,
            name: this.form.name,
            type: 2,
            pid: 0,
          })
          .then((result) => {
            if (result.success) {
              this.dialogLevelVisible = false;
              this.getMaterialListTree();
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
        this.form = {
          name: "",
          sort: 0,
        };
      }
    },
    /**
     * 获取层级树
     */
    getMaterialListTree() {
      this.api.videoInfo
        .getSubjectVideoTree({
          videoCourseId: this.MaterialsVideoCourseId,
          type: 2,
        })
        .then((result) => {
          if (result.success) {
            result.data.forEach((item, index) => {
              item.index = index;
              if (item.attachmentList && item.attachmentList.length > 0) {
                item.attachmentList = this.fixOrder(item.attachmentList);
              }
            });
            this.tableData = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * 删除层级
     */
    groupDelete(id) {
      this.$confirm("确定删除该分组吗?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api.videoInfo
          .delSubjectVideo({
            id: id,
          })
          .then((result) => {
            if (result.success) {
              this.getMaterialListTree();
              this.$message.success(result.message);
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    /**
     *编辑层级信息
     */
    editBtn(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogLevelVisible = true;
    },
    /**
     * 层级上传序号
     */
    getUploadRelationNumber() {
      this.uploadLoading = true;
      this.uploadRelationNum = this.uploadRelationNum + 1;
    },
    /**
     * 上传层级资料
     */
    uploadFileTree(file) {
      console.log(547, file, this.relationId);
      this.uploadArr = [];
      uploadOSS(file, this.Aliyun, "materials")
        .then((result) => {
          let obj = {
            name: file.file.name,
            size: file.file.size,
            type: file.file.type,
            url: result,
          };
          let obj2 = {
            subjectVideoId: this.relationId,
            attachment: obj,
          };
          this.uploadArr.push(obj2);
          let attachmentList = this.tableData.filter(
            (v) => this.relationId == v.id
          )[0].attachmentList;
          if (attachmentList && attachmentList.length > 0) {
            for (let v of this.uploadArr) {
              v.attachment.sort =
                attachmentList[attachmentList.length - 1].sort + 1;
            }
          }
          if (!attachmentList || attachmentList.length <= 0) {
            this.uploadArr[0].attachment.sort = 0;
          }
          if (this.uploadArr.length === this.uploadRelationNum) {
            this.addVideoMaterialsRelation();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * 新增层级资料
     */
    addVideoMaterialsRelation() {
      this.api.videoMaterials
        .addVideoMaterialsRelation(this.uploadArr)
        .then((result) => {
          if (result.success) {
            this.uploadLoading = false;
            this.uploadArr = [];
            this.uploadRelationNum = 0;
            this.getMaterialListTree();
          } else {
            this.uploadArr = [];
            this.uploadNumber = 0;
            this.$message.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * 删除层级资料
     */
    delSubjectVideoRelation(id) {
      this.api.videoInfo
        .delSubjectVideoRelation({
          id,
        })
        .then((result) => {
          if (result.success) {
            this.$message.success("解绑成功");
            this.getMaterialListTree();
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * 编辑层级资料顺序
     */
    updateInfo(item) {
      this.dialogMaterialVisible = true;
      this.editMaterialForm = JSON.parse(JSON.stringify(item.row));
      console.log(this.editMaterialForm);
    },
    // ==============================================
  },
  mounted() {
    // 获取课程id
    this.MaterialsVideoCourseId = this.$route.query.id;
    this.checkStatus(this.MaterialsVideoCourseId);
    this.getMaterialList(this.MaterialsVideoCourseId);
    this.getMaterialListTree();
  },
};
</script>
<style lang="less" scoped>
.top-type {
  background: #fff;
  padding: 20px 10px;
}
.video-style {
  height: 550px;
  width: 940px;
}
.flex-view {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.draggable-tableaaa {
  border-top: 1px solid #d9ebf5;
  border-left: 1px solid #d9ebf5;
  height: 436px;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  .bor {
    font-weight: bolder;
    color: #4e4e4e;
    background-color: rgb(250, 250, 250) !important;
  }

  .draggable-table {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    div {
      padding: 8px 10px;
      font-size: 12px;
      line-height: 23px;
    }

    .htmltittles {
      white-space: nowrap;
      padding: 0px;
      overflow: hidden;
      text-overflow: ellipsis;

      img {
        display: none !important;
      }

      p {
        font-size: 12px !important;
        line-height: 23px !important;
        margin: 0px !important;
        color: #606266 !important;
        white-space: nowrap !important;

        img {
          display: none !important;
        }
      }
    }

    .title {
      width: 60%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .state {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }

      .questionTypeName {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }

      white-space: nowrap;
    }

    .answer {
      width: 13.3%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .delete {
      width: 13.3%;
      cursor: pointer;
      border-bottom: 1px solid #d9ebf5;
      text-align: center;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.two-table {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  height: 500px;
  width: 100%;

  .left-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .left-right-item {
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      border-radius: 50%;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(238, 238, 238, 1);
      font-size: 14px;
      color: #a2aabc;
      margin: 10px;
      cursor: pointer;
    }

    .left-right-item-select {
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      border-radius: 50%;
      background: rgb(64, 158, 255);
      border-width: 1px;
      border-style: solid;
      border-color: rgb(64, 158, 255);
      font-size: 14px;
      color: #ffffff;
      margin: 10px;
      cursor: pointer;
    }
  }
}

p {
  font-size: 14px;
}

.view-content {
  .view-video {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;

    span {
      display: block;
      font-size: 14px;
      line-height: 30px;
    }
  }

  .view-one {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;

    .optint-list {
      display: flex;
      flex-direction: column;
    }

    p {
      display: inline;
    }

    span {
      display: block;
      font-size: 14px;
      line-height: 30px;
    }
  }

  .view-two {
    height: 50px;
    display: flex;
    flex-direction: row;

    p {
      display: inline;
    }

    div {
      width: 50%;
      display: flex;
      flex-direction: row;
      align-items: center;

      span {
        display: block;
        font-size: 14px;
        line-height: 30px;
      }
    }
  }
}

.message {
  display: flex;
  flex-direction: row;

  .state {
    span {
      padding: 4px 8px;
      color: #fff;
      border-radius: 4px;
      margin-right: 10px;
    }
  }

  .questionTypeName {
    span {
      padding: 4px 8px;
      color: #fff;
      border-radius: 4px;
      margin-right: 10px;
    }
  }

  .htmltittle {
    white-space: nowrap;
    height: 23px;
    overflow: hidden;
    text-overflow: ellipsis;

    img {
      display: none !important;
    }

    p {
      font-size: 12px !important;
      font-size: 12px !important;
      margin: 0px !important;
      color: #606266 !important;
      white-space: nowrap !important;

      img {
        display: none !important;
      }
    }
  }
}

.top {
  width: 100%;
  display: flex;
  background: #fff;

  .top-item {
    width: 33.3%;
    margin-left: 10px;

    .item-lable {
      line-height: 30px;
      white-space: nowrap;
      font-size: 12px;
      color: rgb(162, 170, 188);
    }

    .item-value {
      white-space: nowrap;
      font-size: 18px;
      color: rgb(69, 90, 100);
      line-height: 30px;
    }
  }
}

.view-video {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .view-item {
    display: flex;
    flex-direction: row;
    align-items: center;

    span {
    }
  }
}
</style>
<style lang="less" rel="stylesheet/less">
.checkVideo {
  .vjs-big-play-button {
    display: none !important;
  }
}
.operationGroup-flex {
  display: flex;
  .el-input {
    .el-input__inner {
      height: 30px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/videoCourse/checkMaterial.vue